export default {
  processState: 'IDLE',
  selectedFile: null,
  uploadProgress: 0,
  validationResult: null,
  processResult: null,
  uploadDrawerOpen: false,
  deleteDrawerOpen: false,
  currentStep: 1,
  errors: []
};
